import * as Yup from 'yup';

const createTransactionValidation = Yup.object().shape({
  type: Yup.mixed().oneOf(['cash_in', 'cash_out', 'win', 'promotion', 'return', 'refund',]).required(),
  unit: Yup.number().integer().positive()
});

export default createTransactionValidation;
